export default __webpack_public_path__ + "static/media/October_01.5dc3f76a.png";